import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  deleteCountryById,
  getCountryById,
  getCountryList,
  createCountry,
  updateCountryById,
} from "./queries";

const CountryContext = createContext({});

export const useCountryContext = () => useContext(CountryContext);

export const CountryProvider = ({ ...props }) => {
  const [countryList, setCountryList] = useState([]);
  const [countryPerId, setCountryPerId] = useState({});

  const countryListGetter = useCallback(async () => {
    try {
      if (countryList.length === 0) {
        setCountryList(await getCountryList());
      }
    } catch (e) {
      console.error("countryListGetter", e);
      throw e;
    }
  }, [countryList]);

  const countryByIdGetter = useCallback(
    async (id) => {
      try {
        setCountryPerId(await getCountryById(id));
      } catch (e) {
        console.error("countryByIdGetter", e);
        throw e;
      }
    },
    [setCountryPerId]
  );

  const countryDeleteById = useCallback(
    async (id) => {
      try {
        await deleteCountryById(id);
        setCountryList((old) => old.filter((row) => row.id !== id));
      } catch (e) {
        console.error("countryDeleteById", e);
        throw e;
      }
    },
    [setCountryList]
  );

  const countryCreate = useCallback(async (data) => {
    try {
      const country = await createCountry(data);
      setCountryList((old) => [...old, country]);
    } catch (e) {
      console.error("countryCreate", e);
      throw e;
    }
  }, []);

  const countryUpdateById = useCallback(async (id, data) => {
    try {
      const updatedCountry = await updateCountryById(id, data);
      setCountryList((old) =>
        old.map((elm) => (elm.id === updatedCountry.id ? updatedCountry : elm))
      );
      setCountryPerId(updatedCountry);
    } catch (e) {
      console.error("countryUpdateById", e);
      throw e;
    }
  }, []);
  const values = useMemo(
    () => ({
      countryListGetter,
      countryByIdGetter,
      countryDeleteById,
      countryCreate,
      countryUpdateById,
      countryList,
      countryPerId,
      setCountryPerId,
    }),
    [
      countryListGetter,
      countryByIdGetter,
      countryDeleteById,
      countryCreate,
      countryUpdateById,
      countryList,
      countryPerId,
      setCountryPerId,
    ]
  );
  return <CountryContext.Provider value={values} {...props} />;
};
